import {
    ResultObj,
    allFetch
} from "../Domain";


export interface UserDetailParams {
    user_id: string;
}
export interface UserDetailResItem {
    SMT_username: string;
    address: string;
    address_census: string;
    area: string;
    area_census: string;
    birthday: string;
    blood_type: string;
    career_level: string;
    city: string;
    city_census: string;
    cre_time: string;
    disable: string;
    email: string;
    gender: string;
    home_page: string;
    identity_card: string;
    isresign: string;
    mobile_phone: string;
    name: string;
    note: string;
    on_board_date: string;
    position_id: string;
    resign_date: string;
    resign_reason: string;
    telephone: string;
    ucr_id: string;
    ul_id: string;
    ul_name: string;
    username: string;
    insurance_cancel_date: string;
}

export const UserDetail = async (obj: UserDetailParams): Promise<ResultObj<UserDetailResItem[]>> => {
    return await allFetch("User/UserDetail", obj);
};

export interface UserUpdateParams {
    user_id: string;
    username: string;
    name: string;
    gender: string;
    birthday: string;
    telephone: string;
    mobile_phone: string;
    email: string;
    city: string;
    area: string;
    address: string;
    city_census: string;
    area_census: string;
    address_census: string;
    on_board_date: string;
    note: string;
    home_page: string;
    blood_type: string;
    identity_card: string;
    SMT_username: string;
    insurance_cancel_date: string; // 退保日期
}

export const UserUpdate = async (obj: UserUpdateParams): Promise<ResultObj> => {
    return await allFetch("User/UserUpdate", obj);
};

export interface UserLevelDutyHistorySearchParams {
    user_id: string;
    date_start: string;
    date_end: string;
}
export interface UserLevelDutyHistorySearchResItem {
    cre_time: string;
    date_end: string;
    date_start: string;
    duty_json: string;
    note: string;
    ul_code: string;
    ul_id: number;
    ul_name: string;
    user_id: string;
}

export const UserLevelDutyHistorySearch = async (
    obj: UserLevelDutyHistorySearchParams,
): Promise<ResultObj<UserLevelDutyHistorySearchResItem[]>> => {
    return await allFetch("User/UserLevelDutyHistorySearch", obj);
};

export interface UserCareerRankHistorySearchParams {
    user_id: string;
    date_start: string;
    date_end: string;
}
export interface UserCareerRankHistorySearchResItem {
    career_level: number;
    career_rank: string;
    cre_time: string;
    date_end: string;
    date_start: string;
    note: string;
    ucr_id: number;
    ucrh_id: number;
    user_id: string;
}

export const UserCareerRankHistorySearch = async (
    obj: UserCareerRankHistorySearchParams,
): Promise<ResultObj<UserCareerRankHistorySearchResItem[]>> => {
    return await allFetch("User/UserCareerRankHistorySearch", obj);
};

export interface UserUpdateLevelParams {
    user_id: string;
    ul_id: string;
    ucr_id: string;
    career_level: string;
}

export const UserUpdateLevel = async (
    obj: UserUpdateLevelParams,
): Promise<ResultObj> => {
    return await allFetch("User/UserUpdateLevel", obj);
};

export interface UserUpdateDutyParams {
    user_id: string;
    ud_ids: { key: number, value: 'Y' | 'N' | '' }[];
}

export const UserUpdateDuty = async (
    obj: UserUpdateDutyParams,
): Promise<ResultObj> => {
    return await allFetch("User/UserUpdateDuty", obj);
};

export interface UserUpdateCareerRankParams {
    user_id: string;
    ucr_id: string;
    career_level: string;
}

export const UserUpdateCareerRank = async (
    obj: UserUpdateCareerRankParams,
): Promise<ResultObj> => {
    return await allFetch("User/UserUpdateCareerRank", obj);
};

export interface ResetPasswordParams {
    user_id: string;
    new_password: string;
}

export const ResetPassword = async (
    obj: ResetPasswordParams,
): Promise<ResultObj> => {
    return await allFetch("User/ResetPassword", obj);
};

export interface UserSearchParams {
    username?: string;
    name?: string;
    company_id?: string;
    general_manager_id?: string;
    department_id?: string;
    position_id?: string;
    class_id?: string;
    group_id?: string;
    office_id?: string;
    ul_id?: string;
    disable?: string;
    has_ul_id?: string;
    page?: number;
    num_per_page?: number;
}

/**
 * 使用者查詢(同職位&以下的)結果
 */
export interface UserSearchResItem {
    cre_time: string;
    disable: string;
    home_page_name: string;
    name: string;
    name_en: string;
    ul_name: string;
    user_id: string;
    username: string;
}

export const UserSearch = async (
    obj: UserSearchParams,
): Promise<ResultObj<UserSearchResItem[]>> => {
    return await allFetch("User/UserSearch", obj);
};


export interface UserSearchProxyParams {
    user_id: string;
}

/**
 * 使用者查詢(同職位&以下的)結果
 */
export interface UserSearchProxyResItem {
    cre_time: string;
    disable: string;
    home_page_name: string;
    name: string;
    name_en: string;
    ul_name: string;
    user_id: string;
    username: string;
}

/**
 * @description 使用者查詢(選代理人用的，上層一層+同職務+下層全部**排除自己)
 */
export const UserSearchProxy = async (
    obj: UserSearchProxyParams,
): Promise<ResultObj<UserSearchProxyResItem[]>> => {
    return await allFetch("User/UserSearchProxy", obj);
};

export interface UserSearchNoLevelParams {
    username?: string;
    name?: string;
    page?: string;
    num_per_page?: string;
}

export interface UserSearchNoLevelResItem {
    cre_time: string;
    disable: "N" | "Y";
    name: string;
    user_id: string;
    username: string;
}

export const UserSearchNoLevel = async (
    obj: UserSearchNoLevelParams,
): Promise<ResultObj<UserSearchNoLevelResItem[]>> => {
    return await allFetch("User/UserSearchNoLevel", obj);
};

export interface UserDeleteParams {
    user_id: string;
}

export const UserDelete = async (
    obj: UserDeleteParams,
): Promise<ResultObj> => {
    return await allFetch("User/UserDelete", obj);
};

export interface UserCreateParams {
    username: string;
    name: string;
    gender: string;
    birthday: string;
    telephone: string;
    mobile_phone: string;
    email: string;
    city: string;
    area: string;
    address: string;
    city_census: string;
    area_census: string;
    address_census: string;
    on_board_date: string;
    note: string;
    home_page: string;
    blood_type: string;
    identity_card: string;
    SMT_username: string;
}

export const UserCreate = async (obj: UserCreateParams): Promise<ResultObj> => {
    return await allFetch("User/UserCreate", obj);
};

export interface UserRelatedCompanyRecordSearchParams {
    user_id: string;
    rcr_id: string;
    visible: string;
    page: string;
    num_per_page: string;
}

export interface UserRelatedCompanyRecordSearchResItem {
    name: string;
    user_id: string;
    rcr_id: string;
    visible: string;
    date_end: string;
    date_start: string;
}

export const UserRelatedCompanyRecordSearch = async (
    obj: UserRelatedCompanyRecordSearchParams,
): Promise<ResultObj<UserRelatedCompanyRecordSearchResItem[]>> => {
    return await allFetch("User/UserRelatedCompanyRecordSearch", obj);
};

export interface UserSearchAllParams {
    username?: string;
    name?: string;
    company_id?: string;
    general_manager_id?: string;
    department_id?: string;
    position_id?: string;
    class_id?: string;
    group_id?: string;
    office_id?: string;
    ul_id?: string;
    disable?: string;
    page: number;
    num_per_page: number;
    has_ul_id?: string;
}

export type UserSearchAllResItem = {
    cre_time: string;
    disable: string;
    name: string;
    ul_name: string;
    user_id: string;
    username: string;
    level_name?: string;
}

export const UserSearchAll = async (
    obj: UserSearchAllParams,
): Promise<ResultObj<UserSearchAllResItem[]>> => {
    return await allFetch("User/UserSearchAll", obj).then(async (res) => {
        if (res.success) {
            return { ...res, data: res.data.map((item: UserSearchAllResItem) => ({ ...item, level_name: item.ul_name })) };
        } else {
            return res;
        }
    });
};

export interface UserUpdateDisableParams {
    user_id: string;
    disable: string;
}

export const UserUpdateDisable = async (
    obj: UserUpdateDisableParams,
): Promise<ResultObj> => {
    return await allFetch("User/UserUpdateDisable", obj);
};

export interface UserResignParams {
    user_id: string;
    resign_date: string;
    resign_reason: string;
    insurance_cancel_date: string; // 退保日期
}

export const UserResign = async (
    obj: UserResignParams,
): Promise<ResultObj> => {
    return await allFetch("User/UserResign", obj);
};

/**@description 新增使用者關係企業紀錄 (參數)*/
export interface UserRelatedCompanyRecordCreateParams {
    user_id: string;
    name: string; // 企業名稱
    date_start: string;
    date_end: string;
}
/**@description 新增使用者關係企業紀錄 */
export const UserRelatedCompanyRecordCreate = async (
    obj: UserRelatedCompanyRecordCreateParams,
): Promise<ResultObj> => {
    return await allFetch("User/UserRelatedCompanyRecordCreate", obj);
};

/**@description 新增使用者關係企業紀錄 (參數)*/
export interface UserRelatedCompanyRecordUpdateParams {
    rcr_id: string,
    visible: string
}
/**@description 新增使用者關係企業紀錄 */
export const UserRelatedCompanyRecordUpdate = async (
    obj: UserRelatedCompanyRecordUpdateParams,
): Promise<ResultObj> => {
    return await allFetch("User/UserRelatedCompanyRecordUpdate", obj);
};